import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DisconnectOutlined } from '@ant-design/icons';
import css from './ExpiredState.module.less';

export function ExpiredState() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={css.expired}>
      <DisconnectOutlined className={css.icon} />
      <div className={css.message}>
        {t('share.expired', { defaultValue: 'This share link has expired' })}
      </div>
      <Button type="primary" onClick={() => navigate('/')}>
        {t('share.expired.home', { defaultValue: 'Back to home' })}
      </Button>
    </div>
  );
}
